'use client'

import './Tabs.css'

export function Tabs({ items = [], value, onChange, label, style }) {
  return (
    <div className="u-tabs" role="tablist" aria-label={label} style={style}>
      {items.map((it) => (
        <button
          key={it}
          type="button"
          role="tab"
          aria-selected={it === value}
          className={'u-tab' + (it === value ? ' u-tab--on' : '')}
          onClick={() => onChange && onChange(it)}
        >
          {it}
        </button>
      ))}
    </div>
  )
}

export default Tabs
